<ot-checkbox2 *ngFor="let item of checkboxes" [ngModel]="item.checked" [disabled]="item?.disabled"
              (ngModelChange)="changeCheckboxValue(item, $event)">{{item
  .label}}
</ot-checkbox2>
